module.exports = __webpack_public_path__ + "static/media/195.77aac583.webp";